export enum TypePercent {
    OF_TOTAL = "OF_TOTAL",
    OF_PERSONNEL = "OF_PERSONNEL",
    OF_MATIERE = "OF_MATIERE",
}